// extracted by mini-css-extract-plugin
module.exports = {"orderAttributesSlotWrapper":"OrderAttributesSlot_orderAttributesSlotWrapper__AXCz2"};